import NotificationsProvider from './NotificationsProvider'

export default NotificationsProvider
